import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { AsyncAjaxPost } from "../Common/AsyncAjaxService";
import { ResponseCode } from "../../utils/Utils";


const VagaroAPIEnum = {
    GetBusinessData: "merchants/getbusinessdetails"
};

let BusinessData = [];
export const GetBusinessDetails = createAsyncThunk(
    'PostBusinessDetails',
    async (Request, thunkApi) => {
        const Requestdata = {};
        Requestdata.EncryptCode = Request.EncryptCode;
        await AsyncAjaxPost(
            VagaroAPIEnum.GetBusinessData,
            Requestdata,
            Request.access_token,
            function onSuccess(data) {
                if (
                    data != null &&
                    data.data != null &&
                    data.data.responseCode == ResponseCode.Success
                ) {
                    if (data != null && data.data != null && data.data.data != null) {
                        BusinessData = data.data.data;
                    }
                    else {
                        return thunkApi.rejectWithValue([]);
                    }
                } else {
                    return thunkApi.rejectWithValue([]);
                }
            },
            function OnError() {
                return thunkApi.rejectWithValue([]);
            }
        );

        return thunkApi.fulfillWithValue(BusinessData);
    }
)

export const BusinessSlice = createSlice({
    name: 'Business',
    initialState: {
        EncryptionCode: "",
        BusinessID: "",
        UserID: "",
        ReactBusinessId: -2,
        ReactUserID: -2,
        BusinessName: "",
        CDNURL: "",
        UserType: 1,
        CurrencySymbol: '',
        Email: '',
        CountryID: 0,
        Image: '',
        PhotoForInitials: '',
        VagaroURL: '',
        IsMultiple: false,
        IsNewCustomWebSite: false,
        NewCustomizedWebsitePrice: 0,
        WebsiteBuilderParentWebsite: "https://www.vagaro.com/",
        UserName: "",
        IsOpenEditor: false,
        BusinessType: '',
        AdminCDNURL: '',
        BuildInDomain: '',
        MultiLocationBusinessList: [],
        IsMutipleLocation: false,
        IsViewAllowed: false,
        IsModifyAllowed: false,
        DomainSuggestTlds: "",
        IsShowDomainPurchased: false,
        IsComplete: false,
        MerchantLayoutId: "",
        MerchantStyleId: "",
        BusinessGroup: "US02",
        TaxPercentage: "",
        AdminWhiteList: "",
        AmplitudeBusinessID: 0,
        IsPurchasedDomain: false,
        LocationCount: 0,
        TotalLocationCount: 0,
        BusinessIdsToMigrateToMysite: "",
        LastSupportedDateWb: "",
        IsShopOwnerAdmin: false,
        IsPromoCodeAddressBusiness: false,
        EncUBID: "", 
        azContainer: "",
        azContainerURL: "",
        GroupMysite : 0
    },
    reducers: {
        Logout: (state, action) => {
            state.EncryptionCode = "";
            state.BusinessID = "";
            state.UserID = "";
            state.ReactBusinessId = -2;
            state.ReactUserID = -2;
            state.BusinessName = "";
            state.CDNURL = "";
            state.UserType = 1;
            state.CurrencySymbol = '';
            state.Email = '';
            state.CountryID = 0;
            state.Image = '';
            state.PhotoForInitials = '';
            state.VagaroURL = '';
            state.IsMultiple = false;
            state.IsNewCustomWebSite = false;
            state.NewCustomizedWebsitePrice = 0;
            state.WebsiteBuilderParentWebsite = "https://www.vagaro.com/";
            state.UserName = "";
            state.IsOpenEditor = false;
            state.BusinessType = '';
            state.AdminCDNURL = '';
            state.BuildInDomain = '';
            state.MultiLocationBusinessList = [];
            state.IsMutipleLocation = false;
            state.IsViewAllowed = false;
            state.IsModifyAllowed = false;
            state.DomainSuggestTlds = '';
            state.IsShowDomainPurchased = false;
            state.IsComplete = false;
            state.MerchantLayoutId = "";
            state.MerchantStyleId = "";
            state.BusinessGroup = "US02";
            state.TaxPercentage = "";
            state.AdminWhiteList = "";
            state.AmplitudeBusinessID = 0;
            state.IsPurchasedDomain = false;
            state.LocationCount = 0;
            state.TotalLocationCount = 0;
            state.BusinessIdsToMigrateToMysite = "";
            state.LastSupportedDateWb = "";
            state.IsShopOwnerAdmin = false;
            state.IsPromoCodeAddressBusiness = false;
            state.EncUBID = "";
            state.azContainer = "";
            state.azContainerURL = "";
            state.GroupMysite = 0;
        },
        DeactivateWB: (state, action) => {
            state.IsNewCustomWebSite = false;
        },
        ActivateWB: (state, action) => {
            state.IsNewCustomWebSite = true;
        },
        CleanBusinessType: (state, action) => {
            state.BusinessType = '';
        },
        SuccessPurchaseDomain: (state, action) => {
            state.IsPurchasedDomain = true;
        },
        SuccessDeleteDomain: (state, action) => {
            state.IsPurchasedDomain = false;
        },
        UpdateLocationCount: (state, action) => {
            state.LocationCount = action.payload;
        }        
    },
    extraReducers: {
        [GetBusinessDetails.fulfilled]: (state, { payload }) => {
            if (typeof payload !== undefined && payload !== null) {
                state.EncryptionCode = payload.encryptionCode;
                state.BusinessID = payload.encBID;
                state.UserID = payload.encUID;
                state.ReactBusinessId = payload.merchantId;
                state.ReactUserID = payload.userID;
                state.BusinessName = payload.businessName;
                state.CDNURL = payload.cdnurl;
                state.UserType = payload.userType;
                state.CurrencySymbol = payload.currencySymbol;
                state.Email = payload.email;
                state.CountryID = payload.countryID;
                state.Image = payload.image;
                state.PhotoForInitials = payload.photoForInitials;
                state.VagaroURL = payload.vagaroURL;
                state.IsMultiple = payload.isMultiple;
                state.IsNewCustomWebSite = payload.isNewCustomWebSite;
                state.NewCustomizedWebsitePrice = payload.newCustomizedWebsitePrice;
                state.WebsiteBuilderParentWebsite = payload.websiteBuilderParentWebsite;
                state.UserName = payload.userName;
                state.IsOpenEditor = payload.isOpenEditor;
                state.BusinessType = payload.businessType;
                state.AdminCDNURL = payload.adminCDNURL;
                state.BuildInDomain = payload.buildInDomain;
                state.MultiLocationBusinessList = payload.multiLocationBusinessList;
                state.IsMutipleLocation = payload.isMutipleLocation;
                state.IsViewAllowed = payload.isViewAllowed;
                state.IsModifyAllowed = payload.isModifyAllowed;
                state.DomainSuggestTlds = payload.domainSuggestTlds;
                state.IsShowDomainPurchased = payload.isShowDomainPurchased;
                state.IsComplete = true;
                state.MerchantLayoutId = payload.merchantLayoutId;
                state.MerchantStyleId = payload.merchantStyleId;
                state.BusinessGroup = payload.businessGroup;
                state.TaxPercentage = payload.taxPercentage;
                state.AdminWhiteList = payload.adminWhiteList;
                state.AmplitudeBusinessID = payload.amplitudeBusinessID;
                state.IsPurchasedDomain = payload.isPurchasedDomain;
                state.LocationCount = payload.locationCount;
                state.TotalLocationCount = payload.totalLocationCount;
                state.BusinessIdsToMigrateToMysite = payload.businessIdsToMigrateToMysite;
                state.LastSupportedDateWb = payload.lastSupportedDateWb;
                state.IsShopOwnerAdmin = payload.isShopOwnerAdmin;
                state.IsPromoCodeAddressBusiness = payload.isPromoCodeAddressBusiness;
                state.EncUBID = payload.encUBID;
                state.azContainer = payload.azContainer;
                state.azContainerURL = payload.azContainerURL;
                state.GroupMysite = payload.groupMysite;
                
                localStorage.setItem('Group', state.BusinessGroup);
                window.BusinessGroup = state.BusinessGroup;
            }
        }
    }
})


export const {
    Logout, DeactivateWB, ActivateWB, SuccessPurchaseDomain, SuccessDeleteDomain, UpdateLocationCount
} = BusinessSlice.actions


export default BusinessSlice.reducer;
